/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

//REACT Springs
import { useSpring, animated } from "@react-spring/web";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ComplexStatisticsCard({ color, title, count, icon, isAdmin, data }) {
  const navigate = useNavigate();
  const springProps = useSpring({
    from: { number: 0 }, // Start animation from 0
    to: { number: count }, // Animate to count
    config: { tension: 80, friction: 20 }, // Control the animation speed
  });

  const handleIconClick = () => {
    if (isAdmin) {
      navigate("/organization", {
        state: {
          view: data,
        },
      });
    } else {
      navigate("/team");
    }
  };

  return (
    <Card>
      <MDBox
        display="flex"
        justifyContent="space-between"
        // pt={1}
        pt={0.5}
        px={2}
      >
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          // width="4rem"
          // height="4rem"
          // mt={-3}
          width="2.5rem"
          height="2.5rem"
          mt={-1.5}
        >
          <IconButton onClick={handleIconClick} sx={{ color: "inherit" }}>
            {/* <Icon fontSize="medium">{icon}</Icon> */}
            <Icon fontSize="small">{icon}</Icon>
          </IconButton>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography
            variant="button"
            // variant="body2"
            fontWeight="light"
            color="text"
          >
            {title}
          </MDTypography>
          <MDTypography variant="h5">
            <animated.span>
              {springProps.number.to((n) => n.toFixed(0)) /* Round to an integer */}
            </animated.span>
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  isAdmin: PropTypes.bool,
  data: PropTypes.any,
};

export default ComplexStatisticsCard;
